import XLSX from "xlsx";
import { uniqueValidEmail } from "@/utils/utils";

export const getUniqueValidEmail = async (e) => {
    const result = await readXlsxFile(e);
    const emails = result.map(emailVal => emailVal[0]);

    return emails.filter(uniqueValidEmail);
}

export const readXlsxFile = async (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, {
        type: "array"
    });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];

    return XLSX.utils.sheet_to_json(worksheet, {
        header: 1
    });
}

export const getEmailsFromXlsxFile = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (e) => resolve(getUniqueValidEmail(e));
        reader.onerror = error => reject(error);
    });
}

export const createXlsxFile = async (data, sheetName, fileName, colsConfig) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();

    ws['!cols'] = colsConfig;

    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, fileName);
};

export const generateXlsxEmailTemplate = async () => {
    const data = [
        { 'email': 'exemple@test.com' },
        { 'email': 'exemple@test.com' },
        { 'email': 'exemple@test.com' },
        { 'email': 'exemple@test.com' },
        { 'email': 'exemple@test.com' },
    ];
    const colsConfig = [
        {wpx: 100},
    ];

    await createXlsxFile(data, 'emails', 'Notifier_DUE_template.xlsx', colsConfig);
}
